import Vue from 'vue'

import VFacebookLogin from 'vue-facebook-login-component'

Vue.component('vue-facebook-login', VFacebookLogin)
